import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { FormFields } from '../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InsuranceType } from './useInsuranceQuery';
import { AccountType } from '../../../Profile/Accounts/api/useAccountsOptionsQuery';

interface Body extends FormFields {
  clientId: string;
  AccountType: AccountType.Insurance;
  AccountId?: string;
  InsuranceType?: InsuranceType;
}

interface Response {
  AccountId: string;
}

const upsertInsurance = (body: Body): Promise<Response> => {
  return authFetch('/Consumer/AccountUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

export const useUpsertInsuranceMutation = () => {
  return useMutation(upsertInsurance);
};
